/** The waste causes as the office app names them (one list; Analytics and Home read it). */
export const WASTE_CAUSE_LABELS: Record<string, string> = {
  WILTED_ON_FLOOR: "Wilted on floor",
  BROKEN_DURING_PREP: "Broken during preparation",
  STAFF_ACCIDENT: "Staff accident",
  CUSTOMER_RETURN: "Customer return",
  RECEIVING_DAMAGE: "Receiving damage",
  OTHER: "Other",
};

export const wasteCauseLabel = (cause: string): string =>
  WASTE_CAUSE_LABELS[cause] ??
  cause
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/^./, (character) => character.toUpperCase());
